let baseURL = 'https://api.hrxjyjjh.org.cn/';
let wsUrl = "ws://172.18.16.23:2346";
let moblieUrl = 'https://api.hrxjyjjh.org.cn:83/'

export { baseURL, wsUrl, moblieUrl };



// WEBPACK FOOTER //
// ./src/config/index.js